import styled from 'styled-components';

export const ConnectBadgeStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  .connect-line {
    width: 0;
    height: 8px;
    border-right: 1px solid #8a8a8a;
  }
  /* .Polaris-Badge {
    background-color: #91d0ff;
    color: #00527c;
  } */
`;
